import get from 'lodash/get'

import { ASSESSMENT_TYPE_NESTED_ATTRIBUTE_MAP } from '../reducer'
import { buildAssessment } from '../utils/buildAssessment'


export const submitForm = async (state, formValues, assessmentType) => {
  const  {
    fna: {
      [assessmentType]: assessment
    },
    crudActions
  } = state

  const assessmentId = get(assessment, 'id', null)

  const newAssessment = buildAssessment(formValues, assessmentId, assessmentType)

  await crudActions.update({
    [ASSESSMENT_TYPE_NESTED_ATTRIBUTE_MAP[assessmentType]]: newAssessment
  })
}

export const deleteAssessment = async (state, assessmentType) => {
  const {
    fna: {
      [assessmentType]: assessment
    },
    crudActions
  } = state
  await crudActions.update({
    [ASSESSMENT_TYPE_NESTED_ATTRIBUTE_MAP[assessmentType]]: { ...assessment, _destroy: true }
  })
}
